// extracted by mini-css-extract-plugin
export var BannerTextContainer = "BannerText-module--BannerTextContainer--310Am";